// extracted by mini-css-extract-plugin
export var actionButton = "_jm-t";
export var buttonContainer = "_jm-0";
export var buttonContainer2 = "_jm-1";
export var buttonSection = "_jm-2";
export var details = "_jm-3";
export var dropdownItem = "_jm-5";
export var dropdownItemsContainer = "_jm-4";
export var fileInput = "_jm-r";
export var headerButton = "_jm-6";
export var icon = "_jm-7";
export var input = "_jm-8";
export var macroListItem = "_jm-9";
export var mainContent = "_jm-a";
export var microText = "_jm-b";
export var modal = "_jm-w";
export var optionsButton = "_jm-c";
export var paperclip = "_jm-s";
export var pillContent = "_jm-d";
export var preview = "_jm-e";
export var preview2 = "_jm-f";
export var quillEditor = "_jm-q";
export var selectedMacro = "_jm-g";
export var sidebar = "_jm-h";
export var sidebarHeader = "_jm-j";
export var sidebarList = "_jm-i";
export var sidebarListItem = "_jm-k";
export var sidebarSearch = "_jm-l";
export var snoozeDurationWrapper = "_jm-v";
export var statusPillContainer = "_jm-m";
export var tagsContainer = "_jm-n";
export var unselectedMacro = "_jm-o";
export var variable = "_jm-u";
export var wrapper = "_jm-p";